import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    edmsList: [],
    edms: null,
    links: null,
    meta: null,
    filter: {
      tab: '',
      keyword: '',
      status: '',
    },
    edmsTypeOptions: [
      { value: 'storage', text: 'Flash Storage' },
      { value: 'dram', text: 'DRAM Module' },
      { value: 'application', text: 'Application' },
      { value: 'pr', text: 'PR' },
      { value: 'event', text: 'Event' },
      { value: 'market', text: 'Market Watch' },
    ],
  },
  mutations: {
    CLEAR_ALL(state) {
      state.edmsList = [];
      state.edms = null;
    },
    SET_EDMSLIST(state, data) {
      state.edmsList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_EDMS(state, data) {
      state.edms = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setEDMS({ commit }, data) {
      commit('SET_EDMS', data);
    },

    find({ commit, state }) {
      let url = `/edms?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('EDMS'));
          return response.body;
        })
        .then((response) => {
          commit('SET_EDMSLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/edms/${id}`)
        .then((response) => response.body)
        .then(typeAs('EDMS'))
        .then((item) => {
          commit('SET_EDMS', item);
        });
    },

    destroy(_, id) {
      return http(`/edms/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/edms/${id}`, { method: 'PUT', data })
        : http('/edms', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/edms/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    /* 供 Application 綁定EDM 的搜尋/選取清單 (不分頁, 可依 tab 篩選) */
    allEdms(_, tab) {
      const query = tab ? `?tab=${tab}` : '';
      return http(`/edms/all${query}`).then((response) => response.body);
    },

  },
};
